module.exports = "/_next/static/images/monitoring3-95ad4bc54dc220217bb7cea0f27e4d45.jpg";